import { registerUser as apiRegisterUser } from 'api/project'

export const registerUser = (name, lastName, password) => async (dispatch, getState) => {
  const token = getState().auth.invitationToken
  const projectId = getState().project.id
  const createdRegistration = await dispatch(apiRegisterUser(projectId, token, { name, lastName, password }))
  return createdRegistration
}
